/*
 * @Author: Teemo Ding
 * @Date: 2021-12-17 13:17:20
 * @LastEditTime: 2023-05-10 15:19:18
 * @LastEditors: Please set LastEditors
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/SubscriptionBuy/SubscriptionBuyEdit/index.tsx
 */
import { Button } from '@/src/components/Antd';
import { useI18n } from '@/src/hooks/useRouterChange';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import {
  cancelSubscription,
  getSubscriptionDetail,
  getSubscriptionRecipient,
  saveSubscriptionDetail,
  saveSubscriptionRecipient,
} from '@/src/request/order/subscription';
import { i18nGet, replaceI18nVariables } from '@/src/tools/tools';
import { SubscriptionOrderStatus } from '@/src/types/common/order';
import { modal } from '@/src/utils/Modal';
import { useRequest } from 'ahooks';
import { Form } from 'antd';
//import { get } from 'lodash';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router';
import Layout from 'src/layout/DetailPageLayout';
import Element from 'src/layout/EditorPageLayout/Element/Elements';
import InternalInteraction from '../../AllOrders/OrderDetail/InternalInteraction';
import Customer from '../../Components/Customer';
import OrderInfoRight from '../../Components/OrderInfoRight';
import StatusTag from '../../Components/StatusTag';
import FirstOrderGift from './FirstOrderGift';
import OrderRecords from './OrderRecords';
import RecurringProducts from './RecurringProducts';
import { statusText } from './config';
import css from './css.module.less';
import { breadcrumbData } from './tools';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';

interface IParams {
  uuid: string;
}

const formName = 'subscriptionBuyEdit';
enum SubscriptionBuyType {
  PayUpfront = 'PayUpfront',
  RecurringPayment = 'RecurringPayment',
  OneOff = 'OneOff',
}
const permissions = () => {
  const cancel_subscription = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderSubscription,
        operation: EnumOperation.cancel_subscription,
      }),
    ],
  });
  const edit_customer = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderSubscription,
        operation: EnumOperation.edit_customer,
      }),
    ],
  });
  return { cancel_subscription, edit_customer };
};

const calcFrequencyText = (subFrequencyDiscount, { getI18n }) => {
  const { frequencyUnit, frequency, orderCount, subscriptionType } =
    subFrequencyDiscount || {};
  if (subscriptionType === SubscriptionBuyType.RecurringPayment) {
    return orderCount
      ? replaceI18nVariables(
          getI18n('general.subscriptionbuy.frequencyCheckoutWithEnd'),
          frequency,
          getI18n(
            `general.dateTime.${
              frequency > 1
                ? frequencyUnit.toLowerCase()
                : frequencyUnit.toLowerCase()?.replace('s', '')
            }`,
          ),
          orderCount,
          orderCount === 1 ? 'y' : 'ies',
        )
      : replaceI18nVariables(
          getI18n('general.subscriptionbuy.frequencyCheckoutNoEnd'),
          frequency,
          getI18n(
            `general.dateTime.${
              frequency > 1
                ? frequencyUnit.toLowerCase()
                : frequencyUnit.toLowerCase()?.replace('s', '')
            }`,
          ),
        );
  }
  if (subscriptionType === SubscriptionBuyType.PayUpfront) {
    // Pre-paid subscription, deliver every ${frequency} ${unit}, prepay ${orderCount} deliver${s}
    return replaceI18nVariables(
      getI18n('general.subscriptionbuy.frequencyCheckout'),
      frequency,
      getI18n(
        `general.dateTime.${
          frequency > 1
            ? frequencyUnit.toLowerCase()
            : frequencyUnit.toLowerCase()?.replace('s', '')
        }`,
      ),
      orderCount,
      orderCount === 1 ? 'y' : 'ies',
    );
  }
};

const SubscriptionBuyEdit = () => {
  const { cancel_subscription, edit_customer } = permissions();
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const history = useHistory();
  const { uuid: orderUuid }: IParams = useParams();
  const [form] = Form.useForm();
  const [hasModified, setHasModified] = useState(false);

  const { data: subscriptionData = {}, run: _getSubscriptionDetail } =
    useRequest(() => getSubscriptionDetail(orderUuid), {
      onSuccess: (res) => {
        const { status } = res;
        form.setFieldsValue({
          recurringProducts: res.recurringProducts,
          firstOrderGifts: res.firstOrderGifts,
          orderRecords: res.orderRecords,
          status,
        });
      },
    });

  const onFinish = (values) => {
    const { recurringProducts } = values;
    const productPrices = recurringProducts.map((item) => ({
      lineItemUuid: item.uuid,
      amount: item.amount,
    }));
    const data = { uuid: orderUuid, productPrices };
    saveSubscriptionDetail(data).then((data) => {
      setHasModified(false);
    });
  };

  const onValuesChange = () => {
    setHasModified(true);
  };

  const leftGenerate = () => {
    return (
      <Form
        form={form}
        name={formName}
        onValuesChange={onValuesChange}
        onFinish={onFinish}>
        {/* <Element>
          <SalesChannel availableLanguage={availableLanguage} />
        </Element> */}
        <Element>
          <RecurringProducts
            form={form}
            currency={subscriptionData.currency}
            nonOperational
          />
        </Element>
        <Element>
          <FirstOrderGift />
        </Element>
        <Element>
          <OrderRecords currency={subscriptionData.currency} />
        </Element>
        <Element>
          <InternalInteraction
            interaction={subscriptionData.internalInteractions || []}
          />
        </Element>
        {/* <Element>
          <Discount
            form={form}
            discountSelections={discountSelections}
            handleApply={handleApply}
          />
        </Element>
        <Voucher /> */}
      </Form>
    );
  };
  const beforeGoBack = () => {
    history.push('/order/subscriptionBuy/list');
  };
  const handleCancelSubscription = () => {
    cancelSubscription(orderUuid).then((data) => {
      _getSubscriptionDetail();
    });
  };
  const cancelSubscriptionModal = () => {
    modal.error({
      title: getI18n(
        'subscriptionBuy.subscriptionBuy.subscriptionBuyEdit_cancelSubscriptionModal_title',
      ),
      content: getI18n(
        'subscriptionBuy.subscriptionBuy.subscriptionBuyEdit_cancelSubscriptionModal_content',
      ),
      onOkText: getI18n(
        'subscriptionBuy.subscriptionBuy.subscriptionBuyEdit_cancelSubscriptionModal_title',
      ),
      onCancelText: getI18n(
        'subscriptionBuy.subscriptionBuy.subscriptionBuyEdit_onCancelText',
      ),
      onOk: handleCancelSubscription,
      onCancel: () => {
        console.log('cancel');
      },
    });
  };

  const {
    recipientEmail,
    recipientName,
    recipientLastName,
    recipientFirstName,
    recipientPhoneNo,
    registered,
    userRemarks,
    internalRemark,
    shippingAddress,
    shippingAddressLine1,
    shippingAddressLine2,
    customerInteractions,
    languageCode,
    reportingOrderTime,
    salesChannelOrderTime,
    salesChannelTimezoneInGmt,
    firstOrderTime,
    salesChannelName,
    nextOrderTime,
    nextOrderTimezoneInGmt,
    reportingTimezoneInGmt,
  } = subscriptionData;
  return (
    <Layout
      leftPart={leftGenerate()}
      header={
        <div className={css.header}>
          <TopLeft
            goBack={beforeGoBack}
            breadcrumbData={breadcrumbData(subscriptionData.subscriptionBuyId, {
              getI18n,
            })}
          />
          {subscriptionData.status == SubscriptionOrderStatus.Active && (
            <TopRight
              onDiscard={beforeGoBack}
              onSaveDisable={!hasModified}
              onSubmit={() => form.submit()}
              extendButton={
                cancel_subscription ? (
                  <Button
                    className={css.extendButton}
                    danger
                    ghost
                    onClick={cancelSubscriptionModal}>
                    {getI18n(
                      'subscriptionBuy.subscriptionBuy.subscriptionBuyEdit_cancelSubscriptionModal_title',
                    )}
                  </Button>
                ) : null
              }
            />
          )}
        </div>
      }
      rightElements={[
        {
          child: (
            <OrderInfoRight
              title={
                subscriptionData.status ? (
                  <div>
                    <StatusTag
                      className={css.status}
                      status={subscriptionData.status}
                      calculate={statusText({ getI18n })}
                    />
                    <div className={css.dropDown}>
                      {subscriptionData.subscriptionBuyId}
                    </div>
                  </div>
                ) : (
                  getI18n('subscriptionBuy.subscriptionBuy.cartDetails')
                )
              }
              orderDetail={{
                status: [],
                orderTimeTitle: getI18n(
                  'subscriptionBuy.subscriptionBuy.subscriptionBuyEdit_return_orderDetail_title',
                ), // 'Subscription Created Time',
                subTotal: subscriptionData.subTotal || '-',
                productAmount: subscriptionData.totalAmount,
                reportingOrderTime,
                firstOrderTime,
                nextOrderTime,
                nextOrderTimezoneInGmt,
                reportingTimezoneInGmt,
                salesChannelName,
                salesChannelOrderTime,
                salesChannelTimezoneInGmt,
                frequencyText: calcFrequencyText(subscriptionData, { getI18n }),
                discountAmount: subscriptionData.freeGiftsAmount,
                processingFee: subscriptionData.formattedProcessingFee,
                shipping: [
                  {
                    name: subscriptionData.deliveryMethodName || '-',
                    value: subscriptionData.shippingPrice || '-',
                  },
                ],
                tax: [
                  {
                    name: getI18n(
                      'shoppingCartTemplate.shoppingCartTemplate.components_OrderInfoRight_return_tax_orderItemLine',
                    ),
                    value: subscriptionData.totalTax || '-',
                  },
                ],
                total: subscriptionData.totalPrice || '-',
              }}
            />
          ),
        },
        {
          child: (
            <Customer
              salesChannelUuid={null}
              disableRecipientEdit={!edit_customer}
              hideBuyer
              isSubscription
              getRecipientReq={getSubscriptionRecipient}
              saveRecipientReq={saveSubscriptionRecipient}
              hideBillingAddress
              customerDetail={{
                recipientEmail,
                recipientName,
                recipientLastName,
                recipientFirstName,
                recipientPhoneNo,
                registered,
                userRemarks,
                internalRemark,
                shippingAddress,
                shippingAddressLine1,
                shippingAddressLine2,
                orderUuid,
                customerInteractions,
                languageCode,
              }}
              languageCode={languageCode}
              hideOrderInternalRemark
              hideCustomerRemark
              orderUuid={orderUuid}
              reLoadOrderPage={_getSubscriptionDetail}
              // buildData={}
              // recipientInfo={recipientInfo}
              // setRecipientInfo={(value) =>
              //   handleChange(value, setRecipientInfo)
              // }
            />
          ),
        },
      ]}
    />
  );
};

export default SubscriptionBuyEdit;
